const API = process.env.REACT_APP_API || "https://api.sharpwithit.vip";
const WS  = API.replace("https://", "wss://").replace("http://", "ws://");

const req = (method, path, body) =>
  fetch(`${API}/api${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...(body ? { body: JSON.stringify(body) } : {}),
  }).then((r) => {
    if (!r.ok) throw new Error(`${method} ${path} → ${r.status}`);
    return r.json();
  });

export const api = {
  // Auth
  me: () => req("GET", "/auth/me"),
  login: (email, password) => req("POST", "/auth/login", { email, password }),
  logout: () => req("POST", "/auth/logout"),

  // Channels
  getChannels:      ()         => req("GET",    "/voxlane/channels"),
  createChannel:    (data)     => req("POST",   "/voxlane/channels", data),
  updateChannel:    (id, data) => req("PATCH",  `/voxlane/channels/${id}`, data),
  deleteChannel:    (id)       => req("DELETE", `/voxlane/channels/${id}`),
  joinChannel:      (id)       => req("POST",   `/voxlane/channels/${id}/join`),
  leaveChannel:     (id)       => req("POST",   `/voxlane/channels/${id}/leave`),
  getMessages:      (id)       => req("GET",    `/voxlane/channels/${id}/messages`),
  sendMessage:      (id, text) => req("POST",   `/voxlane/channels/${id}/messages`, { text }),
  getPresence:      ()         => req("GET",    "/voxlane/presence"),
  getStats:         ()         => req("GET",    "/voxlane/stats"),
};

export function createWS(channelId, token, handlers) {
  const url = `${WS}/ws/voxlane/${channelId}?token=${token}`;
  const ws = new WebSocket(url);
  ws.binaryType = "arraybuffer";

  ws.onopen    = () => handlers.onOpen?.();
  ws.onclose   = () => handlers.onClose?.();
  ws.onerror   = (e) => handlers.onError?.(e);
  ws.onmessage = (e) => {
    if (typeof e.data === "string") {
      try { handlers.onEvent?.(JSON.parse(e.data)); }
      catch {}
    } else {
      handlers.onAudio?.(e.data);
    }
  };

  // keepalive ping every 10 min (Render free tier sleeps at 15 min idle)
  const ping = setInterval(() => {
    if (ws.readyState === WebSocket.OPEN)
      ws.send(JSON.stringify({ type: "ping" }));
  }, 10 * 60 * 1000);

  ws.close_ = ws.close.bind(ws);
  ws.close = () => { clearInterval(ping); ws.close_(); };

  return ws;
}

export const WS_URL = WS;
